import React, { useState } from "react";
import blocks from "../../utils/BoardBlocks";
import styles from "./index.module.scss";
import Question from "../Question";

export interface BoardProps {
  selected: number;
  pos1?: number;
  pos2?: number;
  pos3?: number;
  pos4?: number;
  userData: {
    id?: String;
    name?: String;
  };
  changeStreak?: (strk: any) => void;
}

function Board({
  selected,
  userData,
  pos1,
  pos2,
  pos3,
  pos4,
  changeStreak,
}: BoardProps) {
  const [bonus, setBonus] = useState(true);
  //   const increase = (inc: number) => {
  //     setSelected(selected + inc);
  //   };

  console.log(userData);

  return (
    <div className={styles.game}>
      {bonus && pos1 === 6 && (
        <Question
          bonus
          setBns={() => setBonus(false)}
          changeStreak={changeStreak}
          close={() => changeStreak && changeStreak(-1)}
        />
      )}
      {/* {JSON.stringify(userData)} */}
      <div className={styles.home}></div>
      {blocks.map((item) => (
        <div
          key={item.id}
          className={`${styles.cell} ${styles[item.color]} 
        ${item.simp1 && styles.simp1}
        ${item.simp2 && styles.simp2}
        ${item.simp3 && styles.simp3}
        ${item.simp4 && styles.simp4}
        ${pos1 === item.id && styles.active1}
        ${pos2 === item.id && styles.active2}
        ${pos3 === item.id && styles.active3}
        ${pos4 === item.id && styles.active4}
        ${item.safe && styles.safe}`}
          style={{
            top: `${item.top}%`,
            bottom: `${item.bottom}%`,
            left: `${item.left}%`,
            right: `${item.right}%`,
          }}
        >
          <p style={{ display: "none" }}>{item.id}</p>
        </div>
      ))}
    </div>
    // <div>
    //   <h1>Board</h1>
    // </div>
  );
}

export default Board;

/* <div class="game">
        <div class="home"></div>
        // <div class="cells blue" style="top: 42.08%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 5.26%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 10.52%;"></div>
        // <div class="cells blue safe" style="top: 42.08%; left: 15.78%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 21.04%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 26.3%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 31.56%;"></div>
        // <div class="cells blue" style="top: 42.08%; left: 36.82%;"></div>

        // <div class="cells blue" style="top: 0; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 5.26%; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 10.52%; left: 42.08%;"></div>
        // <div class="cells blue safe" style="top: 15.78%; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 21.04%; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 26.3%; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 31.56%; left: 42.08%;"></div>
        // <div class="cells blue" style="top: 36.82%; left: 42.08%;"></div>

        <div class="cells red" style="top: 0; left: 47.34%;"></div>
        <div class="cells red" style="top: 5.26%; left: 47.34%;"></div>
        <div class="cells red" style="top: 10.52%; left: 47.34%;"></div>
        <div class="cells red" style="top: 15.78%; left: 47.34%;"></div>
        <div class="cells red safe" style="top: 21.04%; left: 47.34%;"></div>
        <div class="cells red" style="top: 26.3%; left: 47.34%;"></div>
        <div class="cells red" style="top: 31.56%; left: 47.34%;"></div>
        <div class="cells red" style="top: 36.82%; left: 47.34%;"></div>

        // <div class="cells blue" style="top: 0; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 5.26%; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 10.52%; left: 52.6%;"></div>
        // <div class="cells blue safe" style="top: 15.78%; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 21.04%; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 26.3%; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 31.56%; left: 52.6%;"></div>
        // <div class="cells blue" style="top: 36.82%; left: 52.6%;"></div>

        // <div class="cells blue" style="top: 42.08%; right: 36.82%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 31.56%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 26.3%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 21.04%;"></div>
        // <div class="cells blue safe" style="top: 42.08%; right: 15.78%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 10.52%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 5.26%;"></div>
        // <div class="cells blue" style="top: 42.08%; right: 0;"></div>

        // <div class="cells red" style="top: 47.34%; right: 36.82%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 31.56%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 26.3%;"></div>
        // <div class="cells red safe" style="top: 47.34%; right: 21.04%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 15.78%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 10.52%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 5.26%;"></div>
        // <div class="cells red" style="top: 47.34%; right: 0;"></div>

        // <div class="cells blue" style="top: 52.6%; right: 36.82%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 31.56%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 26.3%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 21.04%;"></div>
        // <div class="cells blue safe" style="top: 52.6%; right: 15.78%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 10.52%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 5.26%;"></div>
        // <div class="cells blue" style="top: 52.6%; right: 0;"></div>

        // <div class="cells blue" style="bottom: 0; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 5.26%; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 10.52%; left: 52.6%;"></div>
        // <div class="cells blue safe" style="bottom: 15.78%; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 21.04%; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 26.3%; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 31.56%; left: 52.6%;"></div>
        // <div class="cells blue" style="bottom: 36.82%; left: 52.6%;"></div>

        // <div class="cells red" style="bottom: 0; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 5.26%; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 10.52%; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 15.78%; left: 47.34%;"></div>
        // <div class="cells red safe" style="bottom: 21.04%; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 26.3%; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 31.56%; left: 47.34%;"></div>
        // <div class="cells red" style="bottom: 36.82%; left: 47.34%;"></div>

        // <div class="cells blue" style="bottom: 0; left: 42.08%;"></div>
        // <div class="cells blue" style="bottom: 5.26%; left: 42.08%;"></div>
        // <div class="cells blue" style="bottom: 10.52%; left: 42.08%;"></div>
        // <div
        //   class="cells blue safe"
        //   style="bottom: 15.78%; left: 42.08%;"
        // ></div>
        // <div class="cells blue" style="bottom: 21.04%; left: 42.08%;"></div>
        // <div class="cells blue" style="bottom: 26.3%; left: 42.08%;"></div>
        // <div class="cells blue" style="bottom: 31.56%; left: 42.08%;"></div>
        // <div class="cells blue" style="bottom: 36.82%; left: 42.08%;"></div>

        // <div class="cells blue" style="top: 52.6%; left: 36.82%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 31.56%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 26.3%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 21.04%;"></div>
        // <div class="cells blue safe" style="top: 52.6%; left: 15.78%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 10.52%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 5.26%;"></div>
        // <div class="cells blue" style="top: 52.6%; left: 0;"></div>

        // <div class="cells red" style="top: 47.34%; left: 36.82%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 31.56%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 26.3%;"></div>
        // <div class="cells red safe" style="top: 47.34%; left: 21.04%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 15.78%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 10.52%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 5.26%;"></div>
        // <div class="cells red" style="top: 47.34%; left: 0;"></div>
      </div>
    </div> */
